/* La Pepa · Produkt des Monats (sections/lp-spotlight.liquid), Vorlage _workbench/home-mock/sections/spotlight.js
 * - Einblenden beim Scrollen: is-armed, dann is-in (Produkt, Punkte, Linien, Labels gestaffelt per CSS);
 *   im Theme-Editor und bei reduzierter Bewegung sofort sichtbar. Schleifen pausieren außerhalb des Bildschirms.
 * - Farbwahl (eine Produktoption): Varianten aus dem JSON-Script [data-lp-spot-variants], Preis/Streichpreis/Rabatt nachziehen.
 * - „Add to cart“ über window.LpCart.add (Spinner, Haken, Bild fliegt); ohne LpCart zur Produktseite mit Variante.
 */
(() => {
  if (customElements.get('lp-spotlight')) return;

  customElements.define('lp-spotlight', class extends HTMLElement {
    connectedCallback() {
      const stage = this.querySelector('.lp-spot__stage');
      const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const design = window.Shopify && window.Shopify.designMode;

      if ('IntersectionObserver' in window && stage && !calm && !design) {
        this.classList.add('is-armed');
        this.reveal = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.reveal.disconnect();
          this.classList.add('is-in');
        }, { threshold: 0.35 });
        this.reveal.observe(stage);
        this.pause = new IntersectionObserver(([e]) => this.classList.toggle('is-paused', !e.isIntersecting));
        this.pause.observe(this);
      } else {
        this.classList.add('is-in');
      }

      const data = this.querySelector('script[data-lp-spot-variants]');
      try { this.variants = JSON.parse(data ? data.textContent : '[]'); } catch { this.variants = []; }
      const start = String(this.dataset.variantId || '');
      this.current = this.variants.find((v) => String(v.id) === start) || this.variants.find((v) => v.available) || this.variants[0];

      this.querySelectorAll('.lp-spot__vbtn').forEach((b) => b.addEventListener('click', () => {
        const v = this.variants.find((x) => String(x.id) === b.dataset.vid);
        if (v && v.available) this.setVariant(v);
      }));

      this.add = this.querySelector('[data-add]');
      this.img = this.querySelector('.lp-spot__toy img');
      if (this.add) {
        if (window.LpCart) window.LpCart.decorate(this.add);
        this.add.addEventListener('click', () => this.addToCart());
      }
    }

    disconnectedCallback() {
      if (this.reveal) this.reveal.disconnect();
      if (this.pause) this.pause.disconnect();
    }

    setVariant(v) {
      this.current = v;
      this.querySelectorAll('.lp-spot__vbtn').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.vid === String(v.id))));
      const name = this.querySelector('[data-vname]');
      if (name) name.textContent = v.title;
      const price = this.querySelector('[data-price]');
      if (price) price.textContent = v.price;
      const was = this.querySelector('[data-compare-value]');
      if (was) { was.textContent = v.compare; was.closest('[data-compare]').hidden = !v.compare; }
      const off = this.querySelector('[data-off]');
      if (off) { off.textContent = v.off; off.hidden = !v.off; }
    }

    addToCart() {
      const v = this.current;
      if (!v || !v.available) return;
      if (window.LpCart && typeof window.LpCart.add === 'function') {
        window.LpCart.add({ body: [{ id: v.id, quantity: 1 }], button: this.add, images: [this.img] }).catch(() => {});
      } else {
        location.href = `${this.add.dataset.url}?variant=${v.id}`;
      }
    }
  });
})();
